import moment from 'moment'
import 'moment/locale/th'
import IQuestion from '../interfaces/IQuestion'

export const QUESTION_TYPES = {
  FILE: 'file',
  LONG_TEXT: 'long_text',
  RADIO: 'radio',
  SHORT_TEXT: 'short_text',
}

export const GENERAL_QUESTION = [
  {
    title:
      '1. ขอให้น้องเล่าเรื่องที่ตนเองเคยทำพลาดหรือผิดหวังในอดีตมาหนึ่งอย่าง ตอนนั้นเกิดอะไรขึ้นและน้องได้เรียนรู้อะไรจากเหตุการณ์นั้นบ้าง ถ้าในอนาคตน้องต้องรับมือกับเรื่องเดียวกันนี้อีกครั้ง น้องจะเปลี่ยนแปลงหรือแก้ไขสิ่งที่เกิดขึ้นอย่างไรให้ได้ผลลัพธ์ที่ต่างจากเดิม',
    type: QUESTION_TYPES.LONG_TEXT,
  },
  {
    title:
      '2. อะไรคือสิ่งที่น้องภูมิใจหรือประทับใจในตนเองที่สุด นำเสนอความเป็นตัวเองได้เต็มที่เลย',
    type: QUESTION_TYPES.LONG_TEXT,
  },
]

export const MAJOR_QUESTION = (major: string = 'content'): IQuestion[] => {
  // TODO: replace with major enum
  switch ((major ?? '').toLowerCase()) {
    case 'content':
      return [
        {
          title: `ตอนนี้คุณได้เป็น Content Manager ผู้สร้างคอนเทนต์ให้กับพรรคการเมือง "ก้าวเพื่อพลังประชาภูมิใจกล้ารวมธิปัตย์" มติประชุมพรรคได้กำหนดให้สร้างคอนเทนต์โปรโมท "คุณ A" ผู้สมัครชิงตำแหน่งนายกรัฐมนตรีของพรรค โดยคอนเทนต์นี้ถือเป็น Hero Content ที่จะถูกใช้ไปตลอดแคมเปญ ซึ่งจะต้องมี<br />
          <li>แนะนำผู้สมัคร</li>
          <li>นโยบาย</li>
          <li>สิ่งที่แตกต่างจากพรรคอื่น</li>
          <li>เบอร์ของพรรค</li>
          <br />
          โดยคอนเทนต์นี้ จะเน้นชู "คุณ A" เพื่อเป็นนายกรัฐมนตรีเป็นหลัก ซึ่งยังไม่ได้เป็นที่รู้จักของคนทั้งประเทศมากนัก ทางพรรคคาดหวังว่าคอนเทนต์นี้จะมีความคิดสร้างสรรค์ และแปลกใหม่ เพื่อชูให้คนทั้งประเทศได้สนใจเลือกผู้สมัครมากขึ้น
          <br /><br />
          เงื่อนไข: คุณ A เป็นตัวละครในจินตนาการ จะเป็นเพศใดก็ได้, อายุ, สถานะ, อาชีพ, การศึกษา, นโยบาย สามารถสร้างสรรค์ได้ตามที่ต้องการ (คะแนนจะดูจากการสร้างสรรค์คอนเทนต์เป็นหลัก)
          <br /><br />
          1.1. ทำคอนเทนต์เพื่ออธิบาย ในลักษณะ Format ใดก็ได้ 1 อย่างที่ตนถนัด เช่น
          <li>บล็อก, บทความแบบยาว, บทวิเคราะห์</li>
          <li>วิดีโอสั้นแบบ TikTok, Reels, YouTube Short</li>
          <li>Facebook Post (ใช้ภาพประกอบคำอธิบาย อัลบัม หรืออินโฟกราฟฟิก)</li>
`,
        },
        {
          title:
            '1.2. เขียนอธิบายเหตุผลว่าทำไมถึงเลือกใช้ Format นั้น วิเคราะห์ในมุมของการทำคอนเทนต์ มีข้อดีหรือข้อเสียอย่างไร',
        },
        {
          title:
            '2. จากจำนวนที่คนสมัครมาทั้งหมดหลายร้อยคน จุดแข็งอะไรที่ทำให้น้องคิดว่าตัวเองควรได้รับเลือกเข้าร่วมค่าย JWC ในปีนี้ สำหรับสาขาคอนเทนต์',
        },
      ].map((q, i) => ({
        ...q,
        titleHTML: q.title,
        questionType: 'major',
        major: 'content',
        type: QUESTION_TYPES.LONG_TEXT,
        order: i,
        id: i.toString(),
      }))

    case 'design':
      return [
        {
          title:
            '1. ให้ผู้สมัครสาขา Design อธิบายว่าประสบการณ์ของมนุษย์มีความสัมพันธ์อย่างไรกับความยั่งยืน (Sustainability) และจากการตีความ ผู้สมัครจะสามารถถ่ายทอดแนวคิดนั้นออกมาเป็นรูปแบบของงานออกแบบ UI ได้อย่างไร พร้อมยกตัวอย่าง',
          type: QUESTION_TYPES.LONG_TEXT,
        },
        {
          title:
            '2. จงบอกข้อดีและข้อเสียของเทคโนโลยี A.I. สำหรับช่วยงานออกแบบในยุคปัจจุบัน',
          type: QUESTION_TYPES.LONG_TEXT,
        },
      ].map((q, i) => ({
        ...q,
        titleHTML: q.title,
        questionType: 'major',
        major: 'design',
        type: QUESTION_TYPES.LONG_TEXT,
        order: i,
        id: i.toString(),
      }))
    case 'marketing':
      return [
        {
          title:
            '1. จงอธิบายความรู้และประสบการณ์ทางด้านสาขาวิชาการตลาดที่น้องมี โดยแยกการตลาดออฟไลน์และการตลาดออนไลน์ให้ชัดเจน หากได้รับเลือกสัมภาษณ์ ให้นำเอกสารหรือหลักฐานยืนยันของสิ่งที่ตอบมาแสดงด้วย',
          type: QUESTION_TYPES.LONG_TEXT,
        },
        { title: '', optional: true, type: QUESTION_TYPES.FILE },
        {
          title:
            '2. เพราะเหตุใดน้องจึงควรได้รับเลือกเข้าร่วมค่าย JWC ในปีนี้ สำหรับสาขาการตลาด',
          type: QUESTION_TYPES.LONG_TEXT,
        },
      ].map((q, i) => ({
        ...q,
        titleHTML: q.title,
        questionType: 'major',
        major: 'marketing',
        type: QUESTION_TYPES.LONG_TEXT,
        order: i,
        id: i.toString(),
      }))
    case 'programming':
      return [
        {
          title:
            '1. จงเลือก Technology, Tools, หรือภาษาที่เกี่ยวกับการเขียนโปรแกรมมาหนึ่งอย่างที่อยากให้กรรมการได้ “ลองใช้” (ป้ายยา) และเขียนอธิบายว่าสิ่งสิ่งนั้นคืออะไร ทำไมจึงอยากให้กรรมการได้ลองใช้',
        },
        {
          title:
            '2. งาน Programming งานไหนในชีวิตของคุณที่คุณภูมิใจที่สุด และทำไมถึงภูมิใจในงานนั้น อยากให้ผู้สมัครเล่าให้พวกเราฟัง',
        },
      ].map((q, i) => ({
        ...q,
        titleHTML: q.title,
        questionType: 'major',
        major: 'programming',
        type: QUESTION_TYPES.LONG_TEXT,
        order: i,
        id: i.toString(),
      }))
    default:
      return []
  }
}

export type TrackKey = 'design' | 'programming' | 'marketing' | 'content'

export interface MajorDetail {
  value: TrackKey
  /** English track name — stays in English per the design system */
  name: string
  /** Thai role name from ywc21-landing (content.ts MAJORS) */
  tagline: string
  image: { src: string; width: number; height: number }
}

/** Order and copy follow ywc21-landing/src/components/landing/content.ts */
export const MAJOR_DETAILS: MajorDetail[] = [
  {
    value: 'design',
    name: 'Design',
    tagline: 'นักออกแบบ',
    image: { src: '/ywc21/majors/design.webp', width: 353, height: 245 },
  },
  {
    value: 'programming',
    name: 'Programming',
    tagline: 'นักสร้าง',
    image: { src: '/ywc21/majors/programming.webp', width: 397, height: 268 },
  },
  {
    value: 'marketing',
    name: 'Marketing',
    tagline: 'นักวางกลยุทธ์',
    image: { src: '/ywc21/majors/marketing.webp', width: 237, height: 283 },
  },
  {
    value: 'content',
    name: 'Content',
    tagline: 'นักเล่าเรื่อง',
    image: { src: '/ywc21/majors/content.webp', width: 250, height: 253 },
  },
]

export const MAJOR = (major: string | null | undefined): string => {
  const result = MAJOR_DETAILS.find(
    detail => detail.value === (major ?? '').toLowerCase()
  )
  return result ? result.name : ''
}

/** Public links — confirmed by the YWC21 team on 2026-10-02 */
export const WEBSITE_URL = 'https://ywc.in.th'
export const WEBSITE_LABEL = 'ywc.in.th'
export const FACEBOOK_URL = 'https://www.facebook.com/ywcth'
export const INSTAGRAM_URL = 'https://www.instagram.com/ywcth/'

export const DEADLINE = import.meta.env.VITE_APP_REGISTRATION_DEADLINE
export const OPENDATE = import.meta.env.VITE_APP_REGISTRATION_OPEN
/**
 * วันประกาศรายชื่อผู้มีสิทธิ์สัมภาษณ์ — from ywc21-landing TIMELINE
 * (the landing still marks its timeline as a draft; keep both in sync).
 */
export const RESULT_DATE = '27 ตุลาคม 2569'
// Importing a locale makes it global; restore English so other dates are unchanged.
moment.locale('en')

/** True while the registration window has not opened yet (before OPENDATE). */
export const REGISTRATION_NOT_YET_OPEN = moment().isBefore(OPENDATE)
export const REGISTRATION_OPEN_DATE_LABEL = moment(OPENDATE)
  .locale('th')
  .format('D MMMM เวลา HH:mm น.')
export const INTERVIEW_ANNOUNCEMENT_AFTER = import.meta.env
  .VITE_APP_INTERVIEW_ANNOUNCEMENT_AFTER
export const REGISTRATION_OPEN =
  moment().isAfter(OPENDATE) && moment().isBefore(DEADLINE)
export const INTERVIEW_ANNOUNCEMENT_OPEN = moment().isAfter(
  INTERVIEW_ANNOUNCEMENT_AFTER
)

export const FINALIST_ANNOUNCEMENT_AFTER = import.meta.env
  .VITE_APP_FINALIST_ANNOUNCEMENT_AFTER
export const FINALIST_ANNOUNCEMENT_OPEN = moment().isAfter(
  FINALIST_ANNOUNCEMENT_AFTER
)

export const ALLOWED_TO_LOGIN =
  REGISTRATION_OPEN || INTERVIEW_ANNOUNCEMENT_OPEN || FINALIST_ANNOUNCEMENT_OPEN

export const FORCE_CLOSE = import.meta.env.VITE_APP_FORCE_CLOSE === 'true'

/**
 * Eligibility from the ywc21-landing FAQ: applicants are born in 2003 or later
 * (born 2003–2007, or a bachelor's student born 2003 onwards).
 * EARLIEST is inclusive; LATEST is "today" so a birthdate can't be in the future.
 */
export const ALLOW_BIRTHDATE = {
  EARLIEST: '2003-01-01',
  LATEST: moment().format('YYYY-MM-DD'),
}

/**
 * TODO(YWC21): announcement-page details are not confirmed yet.
 * Replace every value here before the interview / finalist announcements open.
 * An empty string hides that row or link on the page.
 */
/** Pre-camp activity every interview-round passer must join */
export const PRE_CAMP = {
  dates: '28 – 29 พ.ย. 2569',
  time: '13:00 - 16:00 น.',
}

/** Interview time-slot booking page (booking flow comes later) */
export const INTERVIEW_BOOKING_PATH = '/announcement/interview/booking'

export const ANNOUNCEMENT_DETAILS = {
  /** e.g. 'วันเสาร์ที่ 31 ตุลาคม 2569' — landing timeline (draft) says 31 ต.ค. 2569 */
  interviewDate: 'วันเสาร์ที่ 31 ตุลาคม 2569',
  /** Short form for the share card */
  interviewDateShort: '31 ต.ค. 2569',
  interviewWeekday: 'วันเสาร์',
  /** Day + month only, for the narrow date tile on the share card */
  interviewDayMonth: '31 ต.ค.',
  /** Day + full month name, shown after the weekday on the share card */
  interviewDayMonthFull: '31 ตุลาคม',
  interviewYear: '2569',
  /** e.g. 'ออนไลน์ผ่าน Discord' — landing says "สัมภาษณ์ออนไลน์ตามสาขาที่สมัคร" */
  interviewVenue: '',
  interviewVenueNote: '',
  /** Discord invite applicants join after linking their account */
  discordInviteUrl: 'https://discord.gg/d5PhQzqkgP',
  /** Confirmation deadline, e.g. '6 พฤศจิกายน 2569 เวลา 23:59 น.' */
  confirmDeadline: '',
  /** Link to the confirmation form */
  confirmFormUrl: 'https://forms.gle/N6Wb2CMywW9dipkd8',
  /** When reserve calls start, e.g. '7 พฤศจิกายน 2569' */
  reserveCallStart: '',
  /** Time window per interview round, e.g. '10:00 - 12:00' (API values: morning/afternoon/evening) */
  interviewRoundTimes: {
    morning: '',
    afternoon: '',
    evening: '',
  } as Record<string, string>,
}

const INTERVIEW_ROUND_LABELS: Record<string, string> = {
  morning: 'รอบเช้า',
  afternoon: 'รอบบ่าย',
  evening: 'รอบเย็น',
}

export const INTERVIEW_ROUND_NOT_SELECTED = 'ยังไม่ได้เลือก'

export const INTERVIEW_ROUNDS = [
  '9:00-10:00', '10:00-11:00', '11:00-12:00', '13:00-14:00',
  '14:00-15:00', '15:00-16:00', '16:00-17:00',
] as const

/** Thai label + configured time window for an interview round from the API */
export const describeInterviewRound = (round?: string) => {
  const roundKey = (round ?? '').trim().toLowerCase()
  return {
    label: INTERVIEW_ROUNDS.some(time => time === roundKey)
      ? roundKey
      : INTERVIEW_ROUND_LABELS[roundKey] ?? INTERVIEW_ROUND_NOT_SELECTED,
    time: ANNOUNCEMENT_DETAILS.interviewRoundTimes[roundKey] ?? '',
  }
}
